module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogVisible,
      "size": "tiny",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "发起人",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.submitFormData.Initiator),
      callback: function($$v) {
        _vm.$set(_vm.submitFormData, "Initiator", $$v)
      },
      expression: "submitFormData.Initiator"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "对接人",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.submitFormData.PickUp),
      callback: function($$v) {
        _vm.$set(_vm.submitFormData, "PickUp", $$v)
      },
      expression: "submitFormData.PickUp"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "执行人",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.submitFormData.Executor),
      callback: function($$v) {
        _vm.$set(_vm.submitFormData, "Executor", $$v)
      },
      expression: "submitFormData.Executor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "执行时间",
      "required": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.submitFormData.ExecutTime),
      callback: function($$v) {
        _vm.$set(_vm.submitFormData, "ExecutTime", $$v)
      },
      expression: "submitFormData.ExecutTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "事项类型",
      "required": ""
    }
  }, [_c('el-select', {
    staticClass: "formlength",
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.submitFormData.MatterTypeId),
      callback: function($$v) {
        _vm.$set(_vm.submitFormData, "MatterTypeId", $$v)
      },
      expression: "submitFormData.MatterTypeId"
    }
  }, _vm._l((_vm.MatterTypes), function(option) {
    return _c('el-option', {
      key: option.id,
      attrs: {
        "value": option.Id,
        "label": option.MatterTypeName
      }
    })
  })), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    on: {
      "click": _vm.addMatter
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否执行OA工作流流程：",
      "required": "",
      "label-width": "190px"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeIsOA
    },
    model: {
      value: (_vm.submitFormData.IsExecutOA),
      callback: function($$v) {
        _vm.$set(_vm.submitFormData, "IsExecutOA", $$v)
      },
      expression: "submitFormData.IsExecutOA"
    }
  }, _vm._l((_vm.OATypes), function(item, index) {
    return _c('el-radio', {
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.value))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExecutOACodeShow),
      expression: "isExecutOACodeShow"
    }],
    attrs: {
      "label": "OA工作流编号",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.submitFormData.ExecutOACode),
      callback: function($$v) {
        _vm.$set(_vm.submitFormData, "ExecutOACode", $$v)
      },
      expression: "submitFormData.ExecutOACode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "涉及APP订单号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.submitFormData.OrderCode),
      callback: function($$v) {
        _vm.$set(_vm.submitFormData, "OrderCode", $$v)
      },
      expression: "submitFormData.OrderCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "附件",
      "id": "ContainerId"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "id": "addFileBtn"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitFormData.AttaUrl.length > 0),
      expression: "submitFormData.AttaUrl.length>0"
    }],
    staticClass: "file-list"
  }, _vm._l((_vm.submitFormData.AttaUrl), function(file, index) {
    return _c('li', {
      staticClass: "list"
    }, [_c('a', {
      attrs: {
        "href": file.Url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(file.Name))]), _vm._v(" "), _c('i', {
      staticClass: "el-icon-delete delFile",
      on: {
        "click": function($event) {
          _vm.delFile(_vm.submitFormData.AttaUrl, index)
        }
      }
    })])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "事项说明",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.submitFormData.Remark),
      callback: function($$v) {
        _vm.$set(_vm.submitFormData, "Remark", $$v)
      },
      expression: "submitFormData.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.dialogClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1)]), _vm._v(" "), _c('addMatterType', {
    ref: "refAddMatterType",
    on: {
      "reLoadType": _vm.getInitData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-620ba9d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Memorandum/SpecialMatter/components/addSpecialMatter/index.vue
// module id = 1504
// module chunks = 1